<template>
  <div id="LoginRegisterFullPage">
    <div class="login-forms-container modal-wrapper">
      <Logo class = "with-padding-margin" />
      <div id="login-card" class = "modal-card with-border" v-if="isLogin">
        <LoginUser @showregister="goTo('register')"> </LoginUser>
      </div>
      <div id="Register-card" class = "modal-card with-border" v-else>
        <RegisterUser @showlogin="goTo('login')"> </RegisterUser>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from '../UI/Logo'
import LoginUser from './LoginUser'
import RegisterUser from './RegisterUser'
export default {
  name: 'LoginRegisterFullPage',
  props: {
    'isLogin': Boolean,
    'toastMsg': String
  },
  components: {
    Logo,
    LoginUser,
    RegisterUser
  },
  data: () => ({

  }),
  methods: {
    goTo (page) {
      this.$router.push(page)
    }
  },
  created () {
    // do something after creating vue instance
    if (this.toastMsg) {
      this.$toast.open({
        duration: 8000,
        message: this.toastMsg,
        position: 'is-top',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginFullPage.vue